module.exports = __webpack_public_path__ + "img/logo.56af83e8.png";